import React from "react";
import "../../Styles/certified/foodhub.css";

export default function Foodhub() {
  return (
    <>
      <div className="foodhub-certified-details-section">
        <div className="foodhub-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="foodhub-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="foodhub-certified-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="foodhub-certified-badge"
            />
            <div className="foodhub-certified-company-names">
              <a href="https://www.foodhubcareers.com" target="_blank" rel="noopener noreferrer">
                <img src="/assets/foodhub/foodhublogo.png" alt="Foodhub Logo" className="foodhub-certified-company-logo" />
              </a>
              <h1 className="foodhub-certified-full-name">
                Foodhub Software Solutions India Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="foodhub-certified-details-right">
            <img
              src="/assets/foodhub/foodhub1.jpeg"
              alt="Foodhub Office"
              className="foodhub-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="foodhub-certified-description">
          <h2>
            Why Foodhub Software Solutions India Private Limited is an Outstanding Workplaces
          </h2>
          <p>
            Foodhub is a global organisation that is committed to transforming the way takeaways and restaurants manage their daily operations. We specialise in providing a comprehensive digital ecosystem that includes our unique EPOS (Electronic Point of Sale) system and an integrated online ordering platform.<br/>
            Our goal is to make the entire ordering and management process fast, simple, and seamless for our partner restaurants. With our technology, businesses can easily handle in-store orders, online orders, payments, menu updates, and customer management from a single, unified system.<br/>
            One of the key principles that sets us apart in the industry is our 0% commission model. Unlike traditional food-ordering portals that charge restaurants a percentage of every order, we offer our services at a fixed and predictable price. This ensures that our partners retain full control over their revenue and can grow without worrying about increasing commission fees as their order volume rises.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="foodhub-certified-info-cards">
          <div className="foodhub-certified-info-card">
            <div className="foodhub-certified-info-title">COMPANY SIZE</div>
            <div className="foodhub-certified-info-value">1000+ Employees</div>
          </div>
          <div className="foodhub-certified-info-card">
            <div className="foodhub-certified-info-title">INDUSTRY</div>
            <div className="foodhub-certified-info-value">Information Technology</div>
          </div>
          <div className="foodhub-certified-info-card">
            <div className="foodhub-certified-info-title">CONNECT</div>
            <div className="foodhub-certified-info-icons">
              <span className="foodhub-certified-icon-round">
                <a href="https://www.foodhubcareers.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="foodhub-certified-icon-round">
                <a href="https://linkedin.com/in/foodhub-india-ab57152b6" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              {/* <span className="foodhub-certified-icon-round">
                <a href="https://www.facebook.com/foodhub" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="foodhub-certified-icon-round">
                <a href="https://www.instagram.com/foodhub" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/instagram.png" alt="Instagram" />
                </a>
              </span>
              <span className="foodhub-certified-icon-round">
                <a href="https://x.com/foodhub" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span> */}
            </div>
          </div>
          <div className="foodhub-certified-info-card">
            <div className="foodhub-certified-info-title">LOCATION (HQ)</div>
            <div className="foodhub-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="foodhub-certified-recognition-section">
          <h2 className="foodhub-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="foodhub-certified-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="foodhub-certified-recognition-image"
            />
          </div>
          <div className="foodhub-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Foodhub Section */}
        <div className="foodhub-certified-life-section">
          <h2 className="foodhub-certified-life-title">
            Life at Foodhub Software Solutions India Private Limited
          </h2>
          <div className="foodhub-certified-life-gallery">
            <div className="foodhub-certified-life-col">
              <img src="/assets/foodhub/foodhub6.jpg" alt="Office 1" className="foodhub-certified-life-img" />
              <img src="/assets/foodhub/foodhub7.jpg" alt="Meeting 1" className="foodhub-certified-life-img" />
            </div>
            <div className="foodhub-certified-life-col foodhub-certified-life-center">
              <img src="/assets/foodhub/foodhub2.jpg" alt="Main Office" className="foodhub-certified-life-img foodhub-certified-life-img-large" />
            </div>
            <div className="foodhub-certified-life-col">
              <img src="/assets/foodhub/foodhub3.jpg" alt="Office 2" className="foodhub-certified-life-img" />
              <img src="/assets/foodhub/foodhub5.jpg" alt="Meeting 2" className="foodhub-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
